import expenseCategoryService from '../../../services/expenseCategoryService';
import revenueCategoryService from '../../../services/revenueCategoryService';
import { CategoryTreeConfig } from './types';

export const EXPENSE_CATEGORIES: CategoryTreeConfig = {
  noun: 'expense',
  records: 'expenses',
  service: expenseCategoryService,
  permission: 'settings_expense_categories',
  accent: 'primary',
  accountUse: 'expense',
  accountHelp: 'Where expenses in this category are recorded in the books. Leave empty to use the suggestion.',
  examples: { category: 'e.g. Utilities, Repairs', sub: 'e.g. Electricity, Plumbing' },
};

export const INCOME_CATEGORIES: CategoryTreeConfig = {
  noun: 'revenue',
  records: 'revenue entries',
  service: revenueCategoryService,
  permission: 'settings_revenue_categories',
  accent: 'success',
  accountUse: 'income',
  accountHelp: 'Where income in this category is recorded in the books. Leave empty to use the suggestion.',
  examples: { category: 'e.g. Donations, Book sales', sub: 'e.g. Annual appeal, Uniforms' },
};
